<template>
	<div 
		class="gb-cell gb-week-firstday white--text lighten-1 primary"
		color="" 
		tile 
		:style="styleUnitDay" 
	>
		{{ week.firstDay }}
	</div>
</template>
<script>
import { UNIT_WIDTH } from '../data/Const';

export default {
	name: 'GBWeekFirstDay',
	props: [ "week" ],
	computed: {
		styleUnitDay: function() {
			return {
				width: UNIT_WIDTH.DAY + 'px',
			};
		},
	},
};
</script>
<style>
	.gb-week-firstday {
		display: inline-block;
		height: 100%;
		text-align: center;
	}
</style>
